import moment from "moment";
import React, { useRef } from "react";
import { concatNomelocal } from "../../../Atendimento/Tabs/Odontograma/Modal/Orcamento/Constatnts";
import PopperCustomMenu from "../../../../components/Popper/PopperCustomMenu";
import MoreIcon from "../../../../components/Icon/More";
import CloseIcon from "../../../../components/Icon/Close";
import SuccessIcon from "../../../../components/Icon/SuccessIcon";
import string from "../../../../utils/string";
import ArrowCounterIcon from "../../../../components/Icon/ArrowCounterIcon";
import { RedirectIcon } from "../../../../components/Icon";
import { Button } from "../../../../components/ui/Buttons";
import DocumentOnePageIcon from "../../../../components/Icon/DocumentOnePage";
import { applyCurrencyMask } from "../../../../utils/CurrencyMask";
import RepasseIcon from "../../../../components/Icon/RepasseIcon";
import DocumentCheckmark from "../../../../components/Icon/DocumentCheckmark";

export const filtersDefault = {
  procedimentoRealizado: null,
  status: null,
};

export const pageableDTODefault = {
  pageNumber: 0,
  pageSize: 30,
  sortDir: "ASC",
  sortField: "dataHoraLancamento",
};

export const procedimentoRealizadoOptions = [
  {
    value: true,
    label: "Sim",
  },
  {
    value: false,
    label: "Nao",
  },
];

export const statusOptions = [
  {
    value: "PENDENTE_APROVACAO",
    label: "Pendente",
  },
  {
    value: "APROVADO",
    label: "Aprovado",
  },
  {
    value: "REPROVADO",
    label: "Reprovado",
  },
  {
    value: "FINALIZADO",
    label: "Finalizado",
  },
  {
    value: "EM_ANDAMENTO",
    label: "Em andamento",
  },
  {
    value: "CANCELAR_EXECUCAO",
    label: "Cancelado",
  },
];

export const columns = ({ functions, permiteFinalizacaoSemFaturamento }) => {
  return [
    {
      Header: "Nome",
      align: "start",
      getValue: (data) => {
        return data.procedimento.nome;
      },
    },
    {
      Header: "Status",
      align: "start",
      getValue: (data) => {
        const status = statusOptions.find((item) => item.value === data.status);

        return status.label;
      },
    },
    {
      Header: "Valor",
      align: "start",
      getValue: (data) => {
        const orcamentoProcedimento = data.orcamentoAtual?.orcamentoProcedimentos?.find(item => item.procedimentoOdontologico?.id === data?.id)

        return applyCurrencyMask(orcamentoProcedimento?.valorUnitario || "");
      },
    },
    {
      Header: "Valor com desconto",
      align: "start",
      getValue: (data) => {
        const orcamentoProcedimento = data.orcamentoAtual?.orcamentoProcedimentos?.find(item => item.procedimentoOdontologico?.id === data?.id)

        return applyCurrencyMask(orcamentoProcedimento?.valorComDesconto || "");
      },
    },
    {
      Header: "Data finalização",
      align: "start",
      getValue: (data) => {
        const { status, dataHoraFinalizacao } = data || {};
        return status === "FINALIZADO" ? moment(dataHoraFinalizacao).format("DD/MM/YYYY") : "";
      },
    },
    {
      Header: "Faturado",
      align: "start",
      getValue: (data) => {
        if(data.status === "REPROVADO") return "Não";

        return data.orcamentoAtual?.faturado ? "Sim" : "Não";
      },
    },
    {
      Header: "Assinatura presença",
      align: "start",
      getValue: (data) => {
        return data?.orcamentoAtual?.agendamento?.assinaturaPresenca ? "Assinado" : "Não assinado";
      },
    },
    {
      Header: "Executante",
      align: "start",
      getValue: (data) => {
        return data?.executante?.nome || data?.procedimentoRealizado?.profissionalSaude?.nome || "";
      },
    },
    {
      Header: "Ação",
      align: "start",
      isClick: true,
      getValue: (data) => {
        return <PopperMenu row={data} functions={functions} permiteFinalizacaoSemFaturamento={permiteFinalizacaoSemFaturamento} />;
      },
    },
  ];
};

export const procedimentoOdontologicoSelectedDefault = {
  id: null,
  numero: "",
  observacao: "",
  status: "",
  statusOrcamentoOdontologico: null,
  convenio: null,
  procedimentosOdontologicos: [],
};

export const notificationDefault = {
  open: false,
  message: "",
  type: "",
};

export const tabs = {
  ORCAMENTO: 0,
  HISTORICO_AGENDAMENTO: 1,
  AUDITORIA: 2,
};

export const columnsModal = ({ handleRedirect }) => [
  {
    Header: "Nome",
    align: "start",
    getValue: (data) => {
      return data.procedimento.nome;
    },
  },
  {
    Header: "Local",
    align: "start",
    getValue: (data) => {
      const face = data.face;
      const local = data.dente ? data.dente.codigo : data.mucosaOral?.descricao;
      return concatNomelocal(face, local);
    },
  },
  {
    Header: "Status",
    align: "start",
    getValue: (data) => {
      return statusOptions[data.status];
    },
  },
  {
    Header: "",
    align: "center",
    getValue: (data) => {
      return (
        <div>
          <Button 
          shape="circle" 
          kind='transparent' 
          size='mini' 
          onClick={() => handleRedirect(data)}
          bgColor='#F2F2F2' 
          style={{
            width: 30,
            height: 30,
          }}>
            <RedirectIcon/>
          </Button>
        </div>
      )
    },
  },
];

const PopperMenu = ({ row, functions, permiteFinalizacaoSemFaturamento }) => {
  const ref = useRef(null);

  const handleCloseWithAction = (fn) => {
    return () => {
      ref?.current && ref.current.closePopper();
      fn(row);
    };
  };

  return (
    <PopperCustomMenu
      menuOpcoes={menuOpcoes({
        row: row,
        functions: {
          handleFinalizar: handleCloseWithAction(functions?.handleFinalizar),
          handleAprovar: handleCloseWithAction(functions?.handleAprovar),
           handleGerarRepasse: handleCloseWithAction(functions?.handleGerarRepasse),
          handleCancelar: handleCloseWithAction(functions?.handleCancelar),
          handleEmAndamento: handleCloseWithAction(functions?.handleEmAndamento),
          handleNotaFiscal: handleCloseWithAction(functions?.handleNotaFiscal),
        },
        isEdit: true,
        permiteFinalizacaoSemFaturamento,
      })}
      ref={ref}
      iconButton={<MoreIcon color="#505050" />}
      colorButton={{
        background: "#fff",
      }}
    />
  );
};
const menuOpcoes = ({ row, functions, permiteFinalizacaoSemFaturamento }) => {
  const handleCallCurrentFunction = ({ functionName, ...params }) => {
    if (functionName) {
      functionName(row);
      if (
        functions?.closePopper &&
        typeof functions?.closePopper === "function"
      ) {
        functions.closePopper();
      }
    }
  };

  const isReprovado = row?.status === "REPROVADO";

  const optionsMenu = isReprovado ? [] : [
    {
      id: 'pac-pod-btn-fin',
      ativo: (row.orcamentoAtual.faturado || permiteFinalizacaoSemFaturamento) && row.status !== "FINALIZADO",
      icon: <SuccessIcon size="15" color="#505050" />,
      label: "Finalizar",
      onClick: (e) =>
        handleCallCurrentFunction({
          functionName: functions?.handleFinalizar,
          ...e,
        }),
    },
    {
      ativo: row.status !== "FINALIZADO",
      id: 'pac-pod-btn-rep',
      icon: <RepasseIcon size="15" color="#505050" />,
      label: "Gerar repasse",
      onClick: (e) =>
        handleCallCurrentFunction({
          functionName: functions?.handleGerarRepasse,
          ...e,
        }),
    },
    {
      id: 'pac-pod-btn-apr',
      ativo: row.orcamentoAtual.faturado && row.status !== "APROVADO",
      icon: <DocumentCheckmark size="15" color="#505050" />,
      label: "Aprovar",
      onClick: (e) =>
        handleCallCurrentFunction({
          functionName: functions?.handleAprovar,
          ...e,
        }),
    },
    
    {
      ativo: !row.orcamentoAtual.faturado && row.status !== "CANCELADO",
      id: 'pac-pod-btn-can',
      icon: <CloseIcon size="15" color="#505050" />,
      label: "Cancelar",
      onClick: (e) =>
        handleCallCurrentFunction({
          functionName: functions?.handleCancelar,
          ...e,
        }),
    },
    {
      id: 'pac-pod-btn-and',
      ativo: row.orcamentoAtual.faturado && row.status !== "EM_ANDAMENTO",
      icon: <ArrowCounterIcon size="15" color="#505050" />,
      label: "Em andamento",
      onClick: (e) =>
        handleCallCurrentFunction({
          functionName: functions?.handleEmAndamento,
          ...e,
        }),
    },
    {
      id: 'pac-pod-btn-nfi',
      ativo: row.status === "FINALIZADO",
      icon: <DocumentOnePageIcon size="15" color="#505050" />,
      label: "Nota fiscal",
      onClick: (e) =>
        handleCallCurrentFunction({
          functionName: functions?.handleNotaFiscal,
          ...e,
        }),
    }
  ];
  return optionsMenu;
};

export const columnsHistoricoAgendamentos = [
  {
    Header: "Data",
    align: "start",
    getValue: (data) => {
      return data.data;
    },
  },
  {
    Header: "Hora",
    align: "start",
    getValue: (data) => {
      return data.horaFormatada;
    },
  },
  {
    Header: "Situação",
    align: "start",
    getValue: (data) => {
      return data.situacao ? string.capitalize(data.situacao) : "";
    },
  },
  {
    Header: "Profissional",
    align: "start",
    getValue: (data) => {
      return data.profissionalSaude?.nome;
    },
  },
];
